import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { errorLogger } from '../../../utils';
import { fetchSeminars } from '../../../redux/actions/seminars';
import { getArraySeminarSpecifics } from '../../../redux/selectors/seminars';
import { getContent } from '../../../services/api';

import DropdownMenu from '../../../components/DropdownMenu/DropdownMenu';
import Placeholder from '../../../components/Placeholder';
import Seminar from './Seminar';
import Slider from '../../../components/Slider/Slider';

import {
  ClearAllButton,
  Heading,
  List,
  LoadMore,
  Section,
  SectionInner,
  SliderWrapper,
  Title,
} from './SeminarsList.style';

const generateSeminars = (copy, months, seminars, showing) => {
  seminars.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  const items = [];
  for (let i = 0; i < seminars.length; i += 1) {
    const seminar = seminars[i];
    if (i >= showing) {
      break;
    }
    items.push(<Seminar key={seminar.entryId || seminar.key} copy={copy} months={months} seminar={seminar} />);
  }

  return items;

  // .slice(0, 4)
  // .map(seminar => <Seminar key={seminar.entryId || seminar.key} copy={copy} months={months} seminar={seminar} />);
  // .map(seminar => {
  //   if (count < 4) {
  //     count += 1;
  //     return <Seminar key={seminar.entryId || seminar.key} copy={copy} months={months} seminar={seminar} />;
  //   }
  // });
};

/**
 * 「セミナー」画面 > 「セミナーのご案内」画面 > 一覧
 */
class SeminarsList extends React.Component {
  static defaultProps = {
    months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  };

  static propTypes = {
    copy: PropTypes.shape().isRequired,
    fetchSeminars: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    seminars: PropTypes.arrayOf(
      PropTypes.shape({
        address: PropTypes.string,
        category: PropTypes.string,
        date: PropTypes.string,
        description: PropTypes.string,
        location: PropTypes.string,
        name: PropTypes.string,
        photoGallery: PropTypes.arrayOf(PropTypes.shape()),
        slug: PropTypes.string,
        targetAudience: PropTypes.arrayOf(PropTypes.string),
      })
    ).isRequired,
    months: PropTypes.arrayOf(PropTypes.string),
  };

  state = {
    dropdowns: [
      { id: 'category', active: [], options: [] },
      { id: 'location', active: [], options: [] },
      { id: 'targetAudience', labelId: 'target_audience', active: [], options: [] },
    ],
    // hasMore: true,
    isFilterMenuOpen: false,
    // loadingMore: false,
    seminars: [{ key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }],
    showing: 4,
  };

  componentWillMount = () => {
    const { fetchSeminars, locale, seminars } = this.props;

    // if (seminars.length < 4) {
    //   fetchSeminars({ limit: 4 - seminars.length, locale, skip: 0 }).catch(e => {
    //     errorLogger(e);
    //   });
    // }

    if (seminars.length < 4) {
      fetchSeminars({ locale }).catch(e => {
        errorLogger(e);
      });
    }

    getContent({ contentType: 'seminarMenu', locale })
      .then(data =>
        this.setState(state => ({
          dropdowns: state.dropdowns.map(dropdown => ({
            ...dropdown,
            options: data[dropdown.id],
          })),
        }))
      )
      .catch(errorLogger);
  };

  componentDidMount = () => {
    if (this.props.seminars.length > 0) this.updateSeminars();
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { dropdowns } = prevState;
    const { seminars } = prevProps;

    try {
      if (seminars !== this.props.seminars) {
        this.updateSeminars();
      }
    } catch (err) {
      console.log(err);
    }
  };

  filterSeminars = seminars =>
    seminars.filter(entry =>
      this.state.dropdowns
        .map(
          dropdown =>
            dropdown.active.length === 0 ||
            dropdown.active.some(filter => {
              if (Array.isArray(entry[dropdown.id])) {
                return entry[dropdown.id].some(tag => tag === filter);
              }
              return filter === entry[dropdown.id];
            })
        )
        .every(result => result)
    );

  handleLoadMore = () => {
    // const { seminars: allSeminars, locale, fetchSeminars } = this.props;
    // const { seminars, dropdowns } = this.state;
    // const filters = dropdowns.reduce((filters, current) => {
    //   if (current.active.length > 0) {
    //     return { ...filters, [current.id]: current.active.join(',') };
    //   }
    //   return filters;
    // }, {});
    // const availableSeminars = this.filterSeminars(allSeminars).length - seminars.length;
    // if (availableSeminars >= 4) {
    //   this.setState(state => ({ showing: state.showing + 4 }));
    // } else {
    //   this.setState({ loadingMore: true }, () => {
    //     fetchSeminars({ filters, limit: 4, locale, skip: seminars.length })
    //       .then(res => {
    //         if (res.value.length < 4) {
    //           this.setState(state => ({ hasMore: false, loadingMore: false, showing: state.showing + 4 }));
    //         } else {
    //           this.setState(state => ({ loadingMore: false, showing: state.showing + 4 }));
    //         }
    //         return res;
    //       })
    //       .catch(e => {
    //         errorLogger(e);
    //       });
    //   });
    // }

    const { seminars, showing } = this.state;

    if (seminars.length > showing) {
      this.setState(state => ({ showing: state.showing + 4 }));
    }
  };

  handleClearFilters = () => {
    this.setState(state => ({
      // seminars: this.props.seminars.slice(0, 4),
      seminars: this.props.seminars,
      dropdowns: state.dropdowns.map(dropdown => ({
        ...dropdown,
        active: [],
      })),
      isFilterMenuOpen: false,
      showing: 4,
    }));
  };

  handleUpdateDropdown = dropdowns => {
    // this.setState({ dropdowns, hasMore: true, showing: 4 }, () => this.updateSeminars());
    this.setState({ dropdowns, showing: 4 }, () => this.updateSeminars());
  };

  updateSeminars = () => {
    this.setState({ seminars: this.filterSeminars(this.props.seminars) });
  };

  render() {
    // const { dropdowns, hasMore, isFilterMenuOpen, loadingMore, seminars, showing } = this.state;
    const { dropdowns, isFilterMenuOpen, seminars, showing } = this.state;
    const { copy, months, seminars: allSeminars } = this.props;
    return (
      <Section id="seminars-section">
        <Helmet>
          <body style={`overflow: ${isFilterMenuOpen ? 'hidden' : 'auto'};`} />
        </Helmet>

        <Title>{copy.upcoming_seminars || <Placeholder h="20px" w="200px" />}</Title>
        <SectionInner>
          <Heading>
            {copy.filters || <Placeholder h="20px" w="100px" />}
            <ClearAllButton onClick={this.handleClearFilters}>
              {copy.clear_all || <Placeholder h="20px" w="100px" />}
            </ClearAllButton>
          </Heading>

          {/* 絞込み条件 */}
          <DropdownMenu
            copy={copy}
            dropdowns={dropdowns.map(dropdown => ({
              ...dropdown,
              label: copy[dropdown.labelId || dropdown.id] || '...',
            }))}
            onUpdate={this.handleUpdateDropdown}
          />

          {/* セミナー一覧表示部分 */}
          <List>
            {/* {generateSeminars(copy, months, seminars.slice(0, showing))} */}
            {generateSeminars(copy, months, seminars, showing)}
            {/* {loadingMore && generateSeminars(copy, months, [{ key: 1 }])} */}
          </List>
          <SliderWrapper>
            {allSeminars.length === 0 && seminars.length === 0 ? (
              <Placeholder h="400px" w="100%" />
            ) : (
              <Slider options={{ loop: false }} dots={false}>
                {/* {generateSeminars(copy, months, seminars.slice(0, showing))} */}
                {generateSeminars(copy, months, seminars, showing)}
              </Slider>
            )}
          </SliderWrapper>

          {seminars.length > showing ? (
            <LoadMore onClick={this.handleLoadMore}>{copy.load_more || <Placeholder w="100px" h="20px" />}</LoadMore>
          ) : null}

          {/* {hasMore &&
            !loadingMore && (
              <LoadMore onClick={this.handleLoadMore}>{copy.load_more || <Placeholder w="100px" h="20px" />}</LoadMore>
            )}
          {loadingMore && (
            <LoadMore>{copy.loading ? `${copy.loading}...` : <Placeholder w="100px" h="20px" />}</LoadMore>
          )} */}
        </SectionInner>
      </Section>
    );
  }
}

const mapState = state => {
  const { seminars } = state;
  const seminarSpecifics = getArraySeminarSpecifics(state);

  return {
    locale: state.locale,
    months: state.siteOptions.siteCopyMonths,
    seminars: seminarSpecifics.map(seminar => ({
      ...seminars[seminar.seminarType],
      ...seminar,
    })),
  };
};

const mapDispatch = dispatch => ({
  fetchSeminars: params => dispatch(fetchSeminars(params)),
});

export default connect(mapState, mapDispatch)(SeminarsList);



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/SeminarsList/SeminarsList.js